import { useEffect, useState } from "react";
import { Grid, Breadcrumbs } from '@mui/material';
import { useNavigate } from "react-router-dom";
import CustomTable from "../../components/common/CustomTable/CustomTable";
import { ModalConfirm } from "../../components/common/ModalConfirm/ModalConfirm";
import { SupplierModal } from "./components/SupplierModal";
import { useSupplierStore } from "../../hooks/useSupplierStore";
import { emphasize, styled } from '@mui/material/styles';
import Chip from '@mui/material/Chip';

const StyledBreadcrumb = styled(Chip)(({ theme }) => {
    const backgroundColor =
        theme.palette.mode === 'light'
            ? theme.palette.grey[100]
            : theme.palette.grey[800];
    return {
        backgroundColor,
        height: theme.spacing(3),
        color: theme.palette.text.primary,
        fontWeight: theme.typography.fontWeightRegular,
        '&:hover, &:focus': {
            backgroundColor: emphasize(backgroundColor, 0.06),
        },
        '&:active': {
            boxShadow: theme.shadows[1],
            backgroundColor: emphasize(backgroundColor, 0.12),
        },
    };
});

const columns = [
    { type: 'options', field: 'options', label: 'Acciones', align: 'center' },
    { type: 'text', field: 'rut', label: 'Rut', align: 'center' },
    { type: 'text', field: 'name_rz', label: 'Nombre', align: 'center' },
    // { type: 'text', field: 'gender', label: 'Genero', align:'center' },
    // { type: 'text', field: 'birthdate', label: 'Fecha de nacimiento', align:'center' },
    // { type: 'text', field: 'age', label: 'Edad', align:'center' },
    { type: 'text', field: 'type', label: 'Tipo', align: 'center', format: (row) => row.type == 1 ? 'Cliente' : (row.type == 2 ? 'Proveedor' : 'Cliente y Proveedor') },
    { type: 'text', field: 'email', label: 'Correo', align: 'center' },
    { type: 'text', field: 'phone', label: 'Teléfono', align: 'center' },
];

export const SuppliersView = () => {

    const navigate = useNavigate();
    // const { search } = useSelector(selectHeaderState);

    const { setActionSupplier, getSuppliers, deleteSupplier } = useSupplierStore();

    const [loading, setLoading] = useState(false);
    const [suppliers, setSuppliers] = useState<any>([]);
    const [rowSelected, setRowSelected] = useState<any>('');
    const [showModal, setShowModal] = useState<boolean>(false);
    const [showModalConfirm, setShowModalConfirm] = useState<boolean>(false);
    const [showModalDetail, setShowModalDetail] = useState<boolean>(false);
    const [view, setView] = useState<String>('suppliers');
    const [contacts, setcontacts] = useState<boolean>(false);

    const [search, setSearch] = useState<string>('')

    useEffect(() => {
        if (search === '') {
            getSupplierApi()
        } else {
            const timer = setTimeout(() => getSupplierApi(), 500)
            return () => clearTimeout(timer)
        }
    }, [search])

    const getSupplierApi = async () => {
        try {
            setLoading(true);

            const payload: any = {}
            if (search !== '') payload.search = search

            const response = await getSuppliers(payload);
            if (!response) {
                setSuppliers([]);
                setLoading(false);
                return false;
            } else {
                setSuppliers(response.detail);
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
        }
    }

    const onAdd = () => {
        setActionSupplier('add');
        setShowModal(true);
    }
    const onEdit = (rowSelected: any) => {
        setActionSupplier('edit');
        setRowSelected(rowSelected);
        setShowModal(true);
    }
    const onDelete = (rowSelected: any) => {
        setActionSupplier('delete');
        setRowSelected(rowSelected);
        setShowModalConfirm(true);
    }
    const onDetails = (rowSelected: any) => {
        setActionSupplier('detail');
        setRowSelected(rowSelected);
        setShowModalDetail(true);
    }

    const onDeleteConfirm = async () => {
        if (rowSelected) {
            setLoading(true);
            const response = await deleteSupplier(rowSelected.id)
            if (response) {
                getSupplierApi();
                setShowModalConfirm(false);
                setLoading(false);
                setRowSelected('');
            } else {
                setLoading(false);
                return false;
            }
        }
    }

    const clearState = () => {
        setRowSelected('');
    }

    const onSearch = (search) => {
        setSearch(search)
    }

    return (
        <>
            <Breadcrumbs aria-label="breadcrumb" sx={{ mt: 3 }}>
                <StyledBreadcrumb
                    label={"Maestros"}
                />
                <StyledBreadcrumb
                    label={"Proveedor-cliente"}
                    onClick={() => {
                        setView('suppliers');
                        setcontacts(false);
                        setRowSelected('');
                        getSupplierApi();
                    }}
                />
                {
                    contacts && (
                        <StyledBreadcrumb
                            label={"contactos"}
                            onClick={() => { setView('contacts') }}
                        />
                    )
                }
            </Breadcrumbs>

            {
                view == 'suppliers' && (
                    <Grid item xs={12}>
                        <CustomTable
                            title={'Proveedor - Cliente'}
                            columns={columns}
                            loading={loading}
                            rows={suppliers || []}
                            onRowClick={() => { }}
                            hasOptions
                            onAddFn={onAdd}
                            onAddFnName={'Nuevo proveedor/cliente'}
                            // onDetails={onDetails}
                            onDelete={onDelete}
                            onEdit={onEdit}
                            onSearch={onSearch}
                            dense
                        />
                    </Grid>
                )
            }


            {
                showModal && (
                    <SupplierModal
                        open={showModal}
                        closeModal={() => { setShowModal(false) }}
                        supplierSelected={rowSelected}
                        listSuppliers={getSupplierApi}
                        clearState={clearState}
                    />
                )
            }
            {
                showModalConfirm && (
                    <ModalConfirm
                        open={showModalConfirm}
                        closeModal={() => { setShowModalConfirm(false); clearState() }}
                        onConfirm={onDeleteConfirm}
                        status={loading}
                    />
                )
            }
        </>
    )
}